import React from 'react';
import ReactDOM from 'react-dom';
import { ExperienceProvider, ContextBuilder } from '@thd-nucleus/experience-context';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { AppSwitch } from './AppSwitch';
import { getIsCompatiblePage, waitForIdle } from './utils/assistant-utils';

const { experienceContext } = ContextBuilder.client({
  expConfiguration: window?.__EXPERIENCE_PROPS__?.expConfiguration
});

// The loader's stylesheet ships as a non-blocking <link rel="preload"> (see
// postPlugin.js) so it never holds up the host PDP's first paint. Promote it to
// a real stylesheet now that we're mounting, so the styles apply on demand — and
// only on compatible pages that actually render the assistant.
function activateStyles() {
  if (typeof document === 'undefined') return;
  document
    .querySelectorAll('link[data-magic-apron-css][rel="preload"]')
    .forEach((link) => link.setAttribute('rel', 'stylesheet'));
}

function renderApp(container) {
  activateStyles();

  const app = (
    <React.StrictMode>
      <ErrorBoundary name="magic-apron-assistant-loader">
        <ExperienceProvider value={experienceContext}>
          <AppSwitch />
        </ExperienceProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );

  // React 18/19 uses createRoot instead of render, but we want to maintain compatibility with React 16 for now.
  // It will check for createRoot and use it if available.
  if (typeof ReactDOM.createRoot === 'function') {
    ReactDOM.createRoot(container).render(app);
  } else {
    ReactDOM.render(app, container);
  }
}

if (typeof BroadcastChannel !== 'undefined' && getIsCompatiblePage()) {
  waitForIdle(() => {
    const container = document.getElementById('magic-apron-loader');
    if (container) {
      renderApp(container);
    }
  });
}
